import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { KeywordsListItem } from 'src/app/models/keywords-list-item.model';
import { KeywordsFilters, KeywordsOptimizationService } from './keywords-optimization.service';

@Component({
  selector: 'app-keywords-optimization',
  templateUrl: './keywords-optimization.component.html',
})
export class KeywordsOptimizationComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  resultsNumber: Observable<number>;
  dataSource = new MatTableDataSource<KeywordsListItem>([]);
  displayedColumns = ['ean', 'sku', 'brandName', 'platform', 'country', 'tags'];

  filters = new KeywordsFilters();

  constructor(private keywordsService: KeywordsOptimizationService) {}

  ngOnInit(): void {
    this.resultsNumber = this.keywordsService.resultsNumber;
    this.loadResults();
  }

  loadResults(): void {
    this.keywordsService.getKeywords(this.filters).subscribe((resp: KeywordsListItem[]) => {
      this.dataSource.data = resp;
    });
  }

  loadPage(): void {
    this.filters.pageSize = this.paginator.pageSize;
    this.filters.pageNumber = this.paginator.pageIndex;
    this.loadResults();
  }

  onSort(): void {
    this.loadResults();
  }

  search(): void {
    this.paginator.pageIndex = 0;
    this.filters.pageNumber = 0;
    this.loadResults();
  }

  reset(): void {
    this.paginator.pageIndex = 0;
    this.filters.pageNumber = 0;
    this.filters.ean = null;
    this.loadResults();
  }
}
